<template>
  <section>
    <transition name="myDialog">
      <sys-loading :loading="loading" />
    </transition>
    <div v-if="!isMobile" class="container">
      <transition name="myDialog">
        <div v-show="dialogVisible" class="mask">
          <div class="dialog">
            <img @click="dialogVisible = false" src="../assets/img/icon-close.png" />
            <h1>{{ errorMsg.title }}</h1>
            <p>{{ errorMsg.content }}</p>
          </div>
        </div>
      </transition>
      <div class="bgi-img"></div>
      <img class="logo" src="../assets/8day-logo.png" />
      <div class="title">
        <p style="text-align: center;">{{ title[0].toUpperCase() }}</p>
        <p style="text-align: left;position: relative;">
          {{ title[1].toUpperCase() }}
          <img class="title-img" src="../assets/img/icon-200.png" />
        </p>
      </div>
      <div class="form-container">
        <div class="form">
          <img class="register-img" src="../assets/img/register-img.png" />
          <form autocomplete="off">
            <div class="form-item">
              <input v-model="form.userName" maxlength="20" placeholder="(*) Tên đăng nhập" />
            </div>
            <div class="form-item">
              <input v-model="form.phone" maxlength="10" placeholder="(*) Số điện thoại" />
            </div>
            <div class="form-item">
              <input v-model="form.password" type="password" autocomplete="new-password" maxlength="15" placeholder="(*) Mật khẩu" />
            </div>
            <div class="form-item">
              <input v-model="form.email" placeholder="(*) Email" />
            </div>
            <div class="form-item" style="position: relative;">
              <input v-model="form.verificationCode" maxlength="4" style="padding-left: 10px;" />
              <div class="codeImg">
                <span @click="getVerify" v-if="codeImg" class="validateCode">
                  <img class="img" :src="codeImg" alt="code" />
                </span>
              </div>
            </div>

            <v-captcha ref="vcaptcha2" :dialogVisible="dialogVisible" :showCheck="showCheck" @cb="handleConfirm" :vstyle="{ width: '245px', height: '53.6px' }">
              <img class="register-btn" src="../assets/img/register-btn.png" @click="submitRegister" />
            </v-captcha>
          </form>
        </div>
      </div>
    </div>
    <div v-if="isMobile" class="root">
      <transition name="myDialog">
        <div v-show="dialogVisible" class="mask">
          <div class="dialog">
            <img @click="dialogVisible = false" src="../assets/img/icon-close.png" />
            <h1>{{ errorMsg.title }}</h1>
            <p>{{ errorMsg.content }}</p>
          </div>
        </div>
      </transition>
      <div class="logo"></div>
      <div class="title-top"></div>
      <form autocomplete="off">
        <input v-model="form.userName" maxlength="20" placeholder="(*) Tên đăng nhập" />
        <input v-model="form.phone" maxlength="10" placeholder="(*) Số điện thoại" />
        <input v-model="form.password" type="password" maxlength="15" placeholder="(*) Mật khẩu" />
        <input v-model="form.email" placeholder="(*) Email" />
        <div style="width: 98%;position: relative;height: 10.666667vw;margin-bottom: 3%;">
          <input v-model="form.verificationCode" maxlength="4" style="padding-left: 10px;" />
          <div class="codeImg">
            <span @click="getVerify" v-if="codeImg" class="validateCode">
              <img class="img" :src="codeImg" alt="code" />
            </span>
          </div>
        </div>
        <v-captcha ref="vcaptcha1" :dialogVisible="dialogVisible" :showCheck="showCheck" @cb="handleConfirm" :vstyle="{ width: '100%', height: '53.6px' }">
          <div class="register-btn" @click="submitRegister"></div>
        </v-captcha>
      </form>
      <div class="title-middle"></div>
      <img src="../assets/img/mb-bottom.png" width="100%" />
    </div>
  </section>
</template>

<script>
import {
  HOME_TITLE,
  FORM_VALID_MESSAGE,
  DOMAIN_AGENT_CODE
} from "../utils/constant";
import md5 from "js-md5";
import { userRegister, createCustomer, getCode } from "../utils/request";
import { encodePlatformUrl, validForm, isMobile } from "../utils/tools";
import { captcha } from "@/mixins/captcha";
export default {
  name: "Home-slot",
  mixins: [captcha],
  data() {
    return {
      title: HOME_TITLE,
      dialogVisible: false,
      loading: false,
      isMobile: isMobile(),
      form: {
        by: 1,
        email: "",
        inviteCode: "",
        verificationCode: "",
        link: "",
        domain: "",
        password: "",
        phone: "",
        userName: ""
      },
      codeImg: '',
      errorMsg: {
        title: "",
        content: ""
      }
    };
  },

  mounted() {
    window.onresize = () => {
      this.isMobile = isMobile();
    };
    this.getVerify();
  },
  methods: {
    getVerify() {
      getCode({}).then(res => {
        this.codeImg = res.body.data
      })
    },
    submitRegister() {
      let errorMsg = validForm("1", this.form);
      if (Object.keys(errorMsg).length !== 0) {
        this.setDialogMsg(errorMsg.title, errorMsg.content);
        return;
      }
      const params = (this.params = Object.assign({}, this.form));
      if (!/^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/.test(params.password)) {
        this.setDialogMsg(
          FORM_VALID_MESSAGE.registerFailTitle,
          FORM_VALID_MESSAGE.passwordMsg
        );
        return;
      }
      this.handleCheck(this.handleConfirm);
    },
    handleConfirm(params = this.params) {
      this.loading = true;
      params.userName = this.form.userName.toLowerCase();
      params.password = md5(this.form.password);
      params.link = location.host;
      params.domain = this.form.link;
      params.email = this.form.email;
      params.verificationCode = this.form.verificationCode;
      params.inviteCode = DOMAIN_AGENT_CODE[this.form.domain] || "";
      userRegister(params, this.captchaParams)
        .then(res => {
          if (res.data.code == 0) {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerTitle,
              FORM_VALID_MESSAGE.registerMsg
            );
            createCustomer(this.form);
            setTimeout(() => {
              location.href = encodePlatformUrl(
                params.userName,
                params.password
              );
            }, 5000);
          } else {
            this.getVerify();
            this.setDialogMsg(
              FORM_VALID_MESSAGE.registerFailTitle,
              res.data.msg
            );
            this.handleOpen(res.data.code);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
        });
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  height: 100vh;
  background-image: url("../assets/img/bg.png");
  background-size: 100% 100%;
  overflow-y: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-flow: column;
  align-items: center;

  .bgi-img {
    width: 100%;
    height: 1024px;
    position: fixed;
    background-image: url("../assets/img/img-left.png"),
      url("../assets/img/img-right.png");
    background-repeat: no-repeat;
    background-size: 47%;
    background-position: left bottom, right bottom;
  }
  img.logo {
    height: 8vh;
    width: auto;
    margin-top: 5vh;
  }
  .title {
    width: 650px;
    font-family: "Montserrat", "UTMErieBlack";
    font-size: 32px;
    color: #ffffff;
  }
  .title-img {
    position: absolute;
    top: -55px;
    margin-left: 15px;
  }
  .form-container {
    width: 100%;
    img.corner-img {
      width: 40%;
      position: fixed;
    }
    img.corner-img.left {
      left: 0;
      bottom: -62px;
    }
    img.corner-img.right {
      right: 0;
      bottom: -87px;
    }
    .form {
      width: 320px;
      height: 360px;
      margin: 0 auto;
      background: url("../assets/img/bgi-form.png") no-repeat;
      background-size: 100% 100%;
      img {
        width: 230px;
        margin: 0 auto;
        display: block;
      }
      img.register-img {
        position: relative;
        top: -35px;
      }
      img.register-btn {
        width: 245px;
        cursor: pointer;
        margin-top: 10px;
        position: relative;
        &:active {
          top: -2px;
        }
      }
    }
    form {
      width: 260px;
      margin: 0 auto;
      position: relative;
      top: -20px;
      .form-item {
        height: 40px;
        border: 1px solid #ffffff;
        border-radius: 20px;
        margin-bottom: 20px;
        &:first-child {
          background-image: url("../assets/img/icon-username.png");
          background-repeat: no-repeat;
          background-position: 10px;
          background-size: 20px;
        }
        &:nth-child(2) {
          background-image: url("../assets/img/icon-phone.png");
          background-repeat: no-repeat;
          background-position: 10px;
          background-size: 20px;
        }
        &:nth-child(3) {
          background-image: url("../assets/img/icon-password.png");
          background-repeat: no-repeat;
          background-position: 10px;
          background-size: 20px;
        }
        &:nth-child(4) {
          background-image: url("../assets/img/icon-email.png");
          background-repeat: no-repeat;
          background-position: 10px;
          background-size: 20px;
        }
        input {
          height: 100%;
          width: 100%;
          background: transparent;
          font-size: 1em;
          font-weight: 400;
          color: #fff;
          outline: none;
          border: none;
          padding-left: 3em;
        }
        .codeImg {
          cursor: pointer;
          width: 150px;
          height: 100%;
          position: absolute;
          right: 0;
          top: 1px;
          .img {
            width: 150px;
            height: 100%;
            border-radius: 20px;
          }
        }
      }
    }
  }
}

.root {
  background-image: url("../assets/img/mb-bgi.png");
  background-size: 100% 100%;
  overflow-x: hidden;
  display: flex;
  flex-flow: column;
  align-items: center;
  .logo {
    width: 29.21vw;
    height: 8vh;
    margin: 4.8vw 0;
    background: url("../assets/8day-logo.png") no-repeat;
    background-size: 100% 100%;
  }
  .title-top {
    width: 69.866667vw;
    height: 5.866667vw;
    background: url("../assets/img/mb-title-80.png") no-repeat;
    background-size: 100% 100%;
  }
  form {
    width: 90%;
    margin-top: 5.066667vw;
    input {
      width: 98%;
      height: 10.666667vw;
      background-image: none;
      margin-bottom: 3%;
      border-radius: 2.4vw;
      text-indent: 1em;
      background-color: #ffffff;
      outline: none;
      font-size: 1em;
    }
    .codeImg {
      cursor: pointer;
      width: 150px;
      height: 100%;
      position: absolute;
      right: 0;
      top: 1px;
      .img {
        width: 150px;
        height: 100%;
        border-radius: 20px;
      }
    }
    @media screen and (min-width: 768px) {
      input {
        font-size: 1.5em;
      }
    }
    @media screen and (min-width: 1024px) {
      input {
        font-size: 2em;
      }
    }
    .register-btn {
      width: 100%;
      height: 8vh;
      background: url("../assets/img/mb-register-btn.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .title-middle {
    width: 90%;
    height: 11.83vh;
    background: url("../assets/img/mb-title-200.png") no-repeat;
    background-size: 100% 100%;
    margin-top: 2vh;
  }
  .mask {
    .dialog {
      width: 90%;
      padding: 20px 0;
      h1 {
        font-size: 1.5em;
      }
      p {
        font-size: 1em;
      }
      img {
        top: -15px;
        right: -15px;
        width: 40px;
        &:active {
          -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
        }
      }
    }
  }
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
  .dialog {
    width: 35%;
    position: relative;
    background-color: #02245ec9;
    color: #ffffff;
    text-align: center;
    padding: 40px 0;
    img {
      position: absolute;
      top: -30px;
      right: -30px;
      cursor: pointer;
    }
    h1 {
      font-size: 2.5em;
      font-weight: 900;
    }
    p {
      font-size: 1.5em;
    }
  }
}
.myDialog-leave-active,
.myDialog-enter-active {
  transition: opacity 0.3s;
}

.myDialog-enter,
.myDialog-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Slot.vue